import React, { StrictMode } from 'react';
import "./index.css";
import ReactDOM from 'react-dom/client';
import App from './App';
import  { BrowserRouter } from 'react-router-dom'



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 
  <StrictMode>
    <BrowserRouter> 
   <App/>
 </BrowserRouter>
  </StrictMode>
  
  
  
    
  
);


